/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_ad274b2e',
  resizeIsShort: 'resizeIsShort_ad274b2e',
  buttonGroup: 'buttonGroup_ad274b2e',
};

export = styles;

loadStyles([{"rawString":".root_ad274b2e{display:block}.resizeIsShort_ad274b2e{width:400px}.buttonGroup_ad274b2e{margin-bottom:40px}.buttonGroup_ad274b2e button{margin-right:20px}"}]);
/* tslint:enable */